import React from 'react'
import { Link } from 'gatsby'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { RealEstateDataPageComponentData } from 'types'
import { ElementHTML } from '@helpers/helper.rendering'

const Novelties_1 = (props: RealEstateDataPageComponentData) => {
  const { global_data } = props
  const { id: siteId } = global_data
  const {
    title,
    button,
    backgroundSecondary,
    backgroundColor,
    titleElement,
    titleColor,
    subtitle,
    subtitleElement,
    subtitleColor,
    alignCenter,
  } = props
  const noveltyCard = global_data.content?.cardsNovelties?.type_id ?? '1'

  const { data: allBlogData, isLoading, isError } = useGetBlogsQuery({ site: siteId })

  const Card = require(`@components/cardsNovelties/${noveltyCard}`)?.default

  const getFeaturedAndRefillByDate = () => {
    if (allBlogData) {
      const featured = allBlogData.news.filter((new_) => new_.featured)
      const notfeatured = allBlogData.news.filter((new_) => !new_.featured)
      const total = [...featured, ...notfeatured]
      console.log(total)
      return total.slice(0, 4)
      //   while (featured.length < 4) {
      //     const featureds = allBlogData.news.filter((new_) => !new_.featured)
      //     if (featureds.length > 0) {
      //       allBlogData.news
      //         .filter((new_) => !new_.featured)
      //         .map((new_) => {
      //           featured.push(new_)
      //         })
      //     } else {
      //       allBlogData.news.map((new_) => {
      //         featured.push(new_)
      //       })
      //     }
      //   }
      //   return featured.slice(0, 4)
      // }
    }
  }
  return (
    <section
      className={
        'novedades-home b p-y-config pb-0 ' +
        ((isError || allBlogData?.news?.length === 0) && 'd-none')
      }
      style={
        backgroundColor
          ? { backgroundColor: backgroundColor }
          : backgroundSecondary
          ? { backgroundColor: 'var(--secondaryColor' }
          : {}
      }
    >
      <div className="container-fluid">
        <ElementHTML
          children={title}
          elementType={titleElement ?? 'h2'}
          className={'pb-lg-4 pb-5 white ' + (alignCenter ? 'text-start' : 'text-center')}
          style={titleColor ? { color: titleColor } : {}}
        />
        <ElementHTML
          children={subtitle}
          elementType={subtitleElement ?? 'p'}
          className={'pb-5 white subtitle-element ' + (alignCenter ? 'text-start' : 'text-center')}
          style={subtitleColor ? { color: subtitleColor } : {}}
        />
      </div>
      <div className="d-flex flex-column flex-lg-row">
        {isLoading
          ? [1, 2, 3, 4].map((_, index) => (
              <Card
                key={index}
                skeleton={true}
                global_data={global_data}
              />
            ))
          : getFeaturedAndRefillByDate()?.map((n, i) => (
              <Card
                novelty={n}
                key={i}
                global_data={global_data}
              />
            ))}
      </div>
      {button?.link && (
        <div
          className={`footer-container d-flex justify-content-center ${
            backgroundSecondary ? 'mt-0' : ''
          }`}
          style={
            backgroundColor
              ? { backgroundColor: backgroundColor }
              : backgroundSecondary
              ? { backgroundColor: 'var(--secondaryColor' }
              : {}
          }
        >
          <Link
            to={'/' + button?.link}
            className={'btn btn-white white' + (button?.border ? ' border ' : '')}
          >
            {button?.value}
          </Link>
        </div>
      )}
    </section>
  )
}

export default Novelties_1
